export const isLatinRegex = (value) => {
	if (value === '') {
		return true;
	}

	return /^[àèìòùáéíóúýâêîôûãñõäëïöüÿçœßøåæþða-z'.-__]+$/i.test(value)
}

export const isLatinRegexWithSpaces = (value) => {
	if (value === '') {
		return true;
	}

	return /^[àèìòùáéíóúýâêîôûãñõäëïöüÿçœßøåæþða-z'.-__]+([ -][àèìòùáéíóúýâêîôûãñõäëïöüÿçœßøåæþða-z'.-__]+)*$/i.test(value)
}

export const isValidEmailRegex = (value) => {
	return /(?!.{81,})^[A-Za-z0-9._%+-]{1,60}@[A-Za-z0-9]{1,}[a-z0-9A-Z\\.-]{1,}\.[A-Za-z0-9]{2,54}$/.test(value)
}

export const isNotSpecialCharacterRegex = (value) => {
	return /^(?!.*([<>":;/`%#~*)([\]{}=¤!&$+^\\]+|[.-]{2,}))(?![-.])/.test(value)
}


// WEBPACK FOOTER //
// ./src/utilities/content/validateFormFields.js